import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GraphqlService } from './graphql.service';

@Injectable({
  providedIn: 'root'
})
export class OpenLeftNavLinkService {

  constructor(private graphQlService:GraphqlService,private route:Router) { }

  GetLeftNavLink(event){
    var url;  let paraNum;
    var contentPageLink=event.target.dataset.link;
    if(contentPageLink=="contentPage" || event.target.className.includes("ditamap") || event.target.className.includes("pdf-link")){
      var id = event.target.className.includes("ditamap") || event.target.className.includes("pdf-link") ? event.target.innerText : event.target.innerHTML;
      var ids = id.split("-");
      if (id.includes("(")) {
        id = id.split("(")[0];
      }
      if (id.includes("[")) {
        id = id.split("[")[0];
      }
      if (id.includes("to")) {
        id = id.split(" to")[0];
      }
      if (id.includes("through")) {
        id = id.split(" through")[0];
      }
      
      paraNum = id;
      id = ids.length == 4 ? id.split("-").slice(0, 3).join('-') : id;
      this.graphQlService.getNavPathTree(id).subscribe(data=>{
        if (ids.length <= 2) {
          url = id + "/tableOfContent";
          this.route.routeReuseStrategy.shouldReuseRoute = () => false;
          this.route.navigateByUrl(url);
        }
        else if (ids.length <= 4 && ids.length > 2) {
          if (ids[3] != "") {
            url = data[0].itemLink.split('/').length == 3 ? data[0].itemLink.split('/').slice(0, 2).join('/') : data[0].itemLink;
             url = url + "/" + paraNum;
            this.route.routeReuseStrategy.shouldReuseRoute = () => false;
            this.route.navigateByUrl(url);
          }
        }
      });
    }
  }
}
